// extracted by mini-css-extract-plugin
export default {"wrapper":"ChatBox_wrapper__97pYJ","inbox":"ChatBox_inbox__1Jpf8","chatBox":"ChatBox_chatBox__s23ji","center-stage":"ChatBox_center-stage__XSxhM"};